'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var startPageLabelConfig = [{
	name: 'startPageLabel',
	inputType: 'text',
	label: 'Start page label',
	default: 'Home'
}, {
	name: 'startPageURL',
	inputType: 'link',
	label: 'Start page URL',
	default: '/',
	requestKey: 'linkFriendlyName'
}];

exports.default = function (node) {
	return {
		type: 'BREADCRUMBS',
		name: 'Breadcrumbs',
		allowedSections: ['main'],
		disallowedChildren: ['*'],
		category: 'Nav',
		icon: 'far fa-ellipsis-h',
		props: [{
			name: 'delimiter',
			inputType: 'text',
			label: 'Delimiter',
			default: '>'
		}, {
			name: 'startOnHierarchyLevel',
			inputType: 'slider',
			label: 'Start on hierarchy level',
			default: 1,
			min: 1,
			max: 10
		}, {
			name: 'prependWithStartPage',
			inputType: 'checkbox',
			label: 'Prepend with start page',
			default: true
		}].concat(_toConsumableArray(!node || node.props.prependWithStartPage !== false ? startPageLabelConfig : [])),
		hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
	};
};